export enum AutoQaSpotlightType {
  DeadAir = 'deadair',
  RecordingDisclosure = 'recording_disclosure',
  CustomPhraseSearch = 'custom_phrase_search',
}
